import { ChevronLeft, Clock3 } from "lucide-react";

export function OthelloRules({ onBack }: { onBack: () => void }) {
  return (
    <article className="rules-screen">
      <header className="rules-header">
        <button className="icon-button" onClick={onBack} aria-label="Back to games"><ChevronLeft /></button>
        <div><p className="eyebrow">Othello</p><h1>Rules at the table</h1></div>
      </header>

      <div className="rules-hero">
        <div className="othello-hero-grid" aria-hidden="true">
          {Array.from({ length: 16 }, (_, i) => {
            const disc = [5, 6, 9, 10].includes(i) ? (i === 5 || i === 10 ? "light" : "dark") : null;
            return <span key={i} className="mini-cell">{disc && <i className={`mini-disc ${disc}`} />}</span>;
          })}
        </div>
        <div><strong>Own the most discs</strong><span>Flank your opponent’s line and flip it to your color.</span></div>
      </div>

      <section>
        <h2>On your turn</h2>
        <ol className="turn-steps">
          <li><b>1</b><span><strong>Place one disc</strong> on an empty square that traps a straight line of your opponent’s discs.</span></li>
          <li><b>2</b><span><strong>Flip them all.</strong> Every opponent disc between your new disc and another of yours—in any of the eight directions—turns your color.</span></li>
          <li><b>3</b><span><strong>No legal move?</strong> You must pass. If both players pass in a row, the game ends.</span></li>
        </ol>
      </section>

      <section>
        <h2>Flanking</h2>
        <div className="rule-grid">
          <div><span className="rule-label indigo">Bracket</span><strong>Trap a line</strong><p>A move is only legal if it flips at least one disc.</p></div>
          <div><span className="rule-label teal">Corners</span><strong>Can’t be flipped</strong><p>Corner discs are permanent. They anchor edges—fight for them.</p></div>
        </div>
      </section>

      <section>
        <h2>Ending the game</h2>
        <dl className="ending-list">
          <div><dt>Board full</dt><dd>Or neither player can move. The game is over.</dd></div>
          <div><dt>Most discs wins</dt><dd>Count the board. Equal counts are a draw.</dd></div>
        </dl>
      </section>

      <aside className="rules-note">
        <Clock3 />
        <div><strong>Keep the table moving</strong><p>You have 48 hours for each turn. Missing the deadline forfeits the game. Every game expires after 14 days.</p></div>
      </aside>

      <button className="primary-button" onClick={onBack}>Back to games</button>
    </article>
  );
}
